
































































































import Routes from '@/Routes';
import { Component, Vue, Watch } from 'vue-property-decorator';
import AppEvents from '@/AppEvents';
import IApiError from '@/models/IApiError';

@Component({
  components: {
  },
})
export default class ForgotPasswordPage extends Vue {
  loading: boolean = false
  apiErrors: IApiError[] = [];
  model: any = {
      email: '',
  }
  rules: any = {
      required: value => !!value 
        || this.$i18n.translate("validation.rules.required", "Required"),
      email: v => /.+@.+/.test(v) 
        || this.$i18n.translate("validation.rules.email", "Must be a valid E-Mail address"),
  }
  recoveryEmailSent: boolean = false;
  $t: any;
  $tlang: any;

  setLocale(locale){
    this.$store.dispatch("app/setLocale", locale);
  }
 
  async onSendRecoveryEmailClick() {
    this.apiErrors = [];
    this.loading = true;
    try {
      await this.$store.dispatch(
        'user/sendRecoveryEmail', 
        {
          data: this.model
        }
      );
    } catch (e) {
      this.apiErrors = AppEvents.getApiErrorsFromError(e);
      this.loading = false;
      return;
    }
    this.recoveryEmailSent = true;
    this.loading = false;
  }
};
